import React from 'react';
import { Search, Filter } from 'lucide-react';

const OrdersFilters = ({
    searchInput,
    setSearchInput,
    onSearch,
    searchTerm,
    statusFilter,
    setStatusFilter,
    typeFilter,
    setTypeFilter,
}) => {
    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            onSearch();
        }
    };

    return (
        <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex flex-col md:flex-row gap-4">
            <div className="relative flex-1 flex gap-2">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={20} />
                <input
                    type="text"
                    placeholder="Поиск по ID или @username..."
                    className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    onKeyDown={handleSearchKeyDown}
                />
                <button
                    onClick={onSearch}
                    disabled={searchInput.trim() === searchTerm}
                    className="px-4 py-2 rounded-lg bg-indigo-600 text-white disabled:opacity-50"
                >
                    Поиск
                </button>
            </div>
            <div className="relative">
                <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={18} />
                <select
                    className="pl-10 pr-8 py-2 border border-slate-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 appearance-none w-full md:w-auto"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                >
                    <option value="all">Все статусы</option>
                    <option value="success">Оплачено</option>
                    <option value="pending">Ожидание</option>
                    <option value="cancelled">Отменён</option>
                    <option value="error">Ошибка</option>
                </select>
            </div>
            <div>
                <select
                    className="px-3 py-2 border border-slate-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 w-full md:w-auto"
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                >
                    <option value="all">Все типы</option>
                    <option value="automatic">Автоматический</option>
                    <option value="manual">Ручной (/frog)</option>
                </select>
            </div>
        </div>
    );
};

export default OrdersFilters;